module.exports = __webpack_public_path__ + "static/media/cow02.a53195a6.jpg";